import {useODMutation, useODQuery} from '@mdpp/od-react-belt'
import {
  GQLHanmiManager,
  GQLHanmiManagerLoginInput,
  GQLHanmiManagerLoginResponse,
  GQLOkResponse,
} from '@mdpp/common/lib/@types/server.schema'
import {AppOptions} from '../../AppOptions'
import {GQL_LOGOUT,} from '../../common/gqls_common'
import {GQL_GET_HANMI_MANAGER_PROFILE, GQL_LOGIN_HANMI_MANAGER} from "./gqls_hanmi_manager";

export function useHanmiManagerAPIs() {
  const simulateDelay = AppOptions.SIMULATE_DELAY

  const loginHanmiManager = useODMutation<GQLHanmiManagerLoginInput, GQLHanmiManagerLoginResponse>(
      GQL_LOGIN_HANMI_MANAGER,
    simulateDelay
  )
  const logout = useODMutation<void, GQLOkResponse>(GQL_LOGOUT, simulateDelay)
  const getHanmiManagerProfile = useODQuery<void, GQLHanmiManager>(GQL_GET_HANMI_MANAGER_PROFILE, simulateDelay)

  return {
    loginHanmiManager,
    logout,
    getHanmiManagerProfile,
  }
}
